import { FlexColumn } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { useUpdateEffect } from '../../../hooks/useCustomEffects';
import { useStyles } from '../../../hooks/useStyles';
import { editUserState } from '../../../storage/userStates';
import { Schedule } from '../../../types/jobs';
import { UserRequest } from '../../../types/users';
import { DaysPicker } from '../../ui/DaysPicker';
import { TimeByDayPicker } from '../../ui/TimeByDayPicker';

export function UserScheduleFields() {
  const { css } = useStyles();
  const [form, setForm] = useRecoilState(editUserState);
  const [scheduleDays, setScheduleDays] = useState(form.schedule);

  const onChangeInput = (key: keyof UserRequest, value: any) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useUpdateEffect(() => {
    onChangeInput('schedule', scheduleDays);
  }, [scheduleDays]);

  return (
    <FlexColumn
      classNames={css({
        minHeight: '450px',
      })}
    >
      <DaysPicker
        enabledDays={scheduleDays.map((day) => day.day)}
        onChange={(scheduleDays) => {
          const d: Array<Schedule | undefined> = scheduleDays
            .map((day, index: unknown) => {
              if (!day) return undefined;
              return {
                ...(form.schedule?.find((d) => {
                  return d.day === index;
                }) || {
                  day: index as 0 | 1 | 2 | 3 | 4 | 5 | 6,
                  endHour: undefined,
                  startHour: undefined,
                  allDay: true,
                }),
              };
            })
            .filter((notUndefined) => notUndefined !== undefined);
          setScheduleDays(d as Schedule[]);
        }}
      />
      <TimeByDayPicker
        days={form.schedule}
        onChange={(days) => {
          onChangeInput('schedule', days);
        }}
      />
    </FlexColumn>
  );
}
